<template>
  <main-content>
    <page-title title_text="پشتیبانی" icon="support"></page-title>
    <div class="row mt-5">
      <div class="col-12 col-md-4 my-2">
        <div class="bg-white shadow-sm h-100" style="border-radius: 20px">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                p-4
                flex-lg-wrap flex-xl-nowrap
              "
            >
              <div class="d-flex flex-column ml-5">
                <h4 class="h4 text-dark bg-white mb-3">سوالات متداول</h4>
                <p class="text-dark-50">
                  لطفاً پیش از ارسال ایمیل یا تماس تلفنی، ابتدا سوالات متداول را
                  مشاهده کنید.
                </p>
              </div>
              <div>
                <a
                  href="https://paystar.ir/faq"
                  target="_blank"
                  class="btn font-weight-bolder btn-success py-2 px-6"
                >
                  مشاهده
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 my-2">
        <div class="bg-white shadow-sm h-100" style="border-radius: 20px">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                p-4
                flex-lg-wrap flex-xl-nowrap
              "
            >
              <div class="d-flex flex-column ml-5">
                <h4 class="h4 text-dark bg-white mb-3">راهنمای سامانه</h4>
                <p class="text-dark-50">
                  تمام اطلاعات لازم برای استفاده از سرویس های متنوع پی استار
                  همراه با ویدیوهای آموزشی را در این بخش دریافت کنید.
                </p>
              </div>
              <div>
                <a
                  href="https://paystar.ir/help"
                  target="_blank"
                  class="btn font-weight-bolder btn-success py-2 px-6"
                >
                  مشاهده
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 my-2">
        <div class="bg-white shadow-sm h-100" style="border-radius: 20px">
          <div class="card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                p-4
                flex-lg-wrap flex-xl-nowrap
              "
            >
              <div class="d-flex flex-column ml-5">
                <h4 class="h4 text-dark bg-white mb-3">مستندات فنی</h4>
                <p class="text-dark-50">
                  جهت اتصال انواع درگاه به سایت یا اپلیکیشن خود، می توانید از وب
                  سرویس یا پلاگین های متنوع استفاده نمایید.
                </p>
              </div>
              <div>
                <div class="dropdown">
                  <button
                    class="btn font-weight-bolder btn-success py-2 px-4 dropdown-toggle app-dropdown-action-button"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    مستندات
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a class="dropdown-item" href="https://paystar.ir/plugin">پلاگین ها</a>
                    <a class="dropdown-item" href="https://docs.paystar.ir/docs/intro/">وب سرویس</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 bg-white shadow-sm p-4" style="border-radius: 10px">
      <tickets :ChangeStatus="changeStatus"></tickets>
      <ticketsempty v-if="status == 'loading'"></ticketsempty>
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import tickets from "@/pages/ticket/tickets";
import $ from "jquery";
import { ticketService } from "@/common/api.service";
import ticketsempty from "@/pages/ticket/components/tickets_empty";
import PageTitle from "@/components/main/components/pageTitle";

export default {
  name: "Get",
  components: { PageTitle, ticketsempty, MainContent, tickets },
  data() {
    return {
      status: "loading",
    };
  },
  mounted() {
    window.localStorage.setItem("support_page_visited", "1");
  },
  methods: {
    createTicket(e, query) {
      let form = $(e.target);
      let btn = $("#submit_button");

      form.validate({
        ignore: ":hidden",

        rules: {
          subject: {
            required: true,
          },
          category_id: {
            required: true,
          },
          content: {
            required: true,
          },
          priority: {
            required: true,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      ticketService
        .create(query)
        .then((response) => {
          this.$router.push("/tickets");
          this.showMsg(form, "success", response.data.message);
          this.$store.dispatch("badgeCounter/countData");
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {});
    },
    changeStatus(status) {
      this.status = status;
    },
  },
};
</script>

<style scoped>
</style>